import enLang from "./entries/en_US";
import viLang from "./entries/vi_VN";

const AppLocale = {
  vi: viLang,
  en: enLang,
};

export default AppLocale;
